// Configuraciones de filtros para TanStack Table
export const createSelectFilter = (dataSource: string[]) => ({
  filterFn: 'includesString',
  meta: {
    filterVariant: 'select',
    selectOptions: dataSource?.map(c => ({ value: c, label: c })) || [],
  },
});

export const createSelectFilterWithTransform = (dataSource: string[], transformFn: (item: string) => { value: string; label: string }) => ({
  filterFn: 'includesString',
  meta: {
    filterVariant: 'select',
    selectOptions: dataSource?.map(transformFn) || [],
  },
});

export const createCapitalizeFilter = (dataSource: string[]) => 
  createSelectFilterWithTransform(
    dataSource,
    c => ({ value: c, label: c.replace(/\b\w/g, match => match.toUpperCase()) })
  );